import { api } from '../../../services/api/apiClient';
import type { Query } from '../../../types/api';
import type { DashboardCharts, DashboardData } from '../../dashboard/types/dashboardTypes';

/** Reports are read-only summaries; each one has its own endpoint under /reports. */
export const reportService = {
  get: <T = any>(path: string, query?: Query) => api.get(path, query).then((r) => r.data as T),
  dashboard: () => api.get('/reports/dashboard').then((r) => r.data as DashboardData),
  dashboardCharts: (months: 6 | 12) => api.get('/reports/dashboard/charts', { months }).then((r) => r.data as DashboardCharts),
};
